import React, { Component } from 'react';
import externallink from '../../images/logos/New window.png';
import maineCDCLogo from '../../images/logos/desktop/DHHS-Logo.png';

class Footer extends Component {

  render() {
    const footerYear = new Date().getFullYear();
    return (
      <footer>
      <div className="container">
      <div className="row">
      <h2>Get Support.</h2>
      </div>
        <div className="row">
          <div className="footer-flex">
            <div className="copy-flex">
              <div className="copy-row first-row">

                <h3>Help With Quitting Tobacco</h3>
                <p>The first step to quitting tobacco is being ready. The Maine QuitLink can help you get started.</p>
                <a href="http://mainequitlink.com/" className="solid-button" target="_blank" rel="noopener noreferrer">Visit The Maine QuitLink <img src={externallink} alt="quitlink"/></a>
              </div>
              <div className="copy-row last-row">
                <h3>Help With Quitting Alcohol and Other Substances</h3>
                <p>211 Maine provides a toll-free statewide information and referral helpline for individuals seeking services.</p>
                <a className="solid-button" href="https://211maine.org/" target="_blank" rel="noopener noreferrer">Visit 211 <img src={externallink} alt="211"/></a>
              </div>
            </div>
            <div className="image-col">
            <a href=""><img src={maineCDCLogo} alt="CDC Logo"/></a>
            <p>Copyright &copy; { footerYear }. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>

    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js